import { UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { usePortalMutation } from 'src/Libs/api'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { resendReferalCode } from '../apis'

interface UseResendReferalCodeParams {
  onSuccess?: () => void
  onError?: (error: AuthFetchError) => void
}

interface UseResendReferalCodeVariables {
  referalCodeId: number
}

type UseResendReferalCode = (params: UseResendReferalCodeParams) => UseMutationResult<void | null, unknown, UseResendReferalCodeVariables>

/**
 * This hook is used to resend the referral code as email
 * @param onSuccess - Callback function to be called on success
 * @param onError - Callback function to be called on error
 * @returns Mutation result
 */
export const useResendReferalCode: UseResendReferalCode = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  const mutationResult = usePortalMutation({
    mutationFn: (vars: UseResendReferalCodeVariables) => resendReferalCode(vars.referalCodeId, authFetch),
    onSuccess: () => onSuccess?.(),
    onError: (error: AuthFetchError) => onError?.(error),
  })

  return mutationResult
}
